import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import Header from './Header';

export default withCustomMetrics({
    page: 'Booking',
})(Header);
